import React, { useMemo } from "react";
import { Box, Button, Typography, Select, MenuItem } from "@mui/material";
import PropTypes from "prop-types";

const PaginationControl = ({
  page,
  setPage,
  totalPages,
  pageSize,
  setPageSize,
}) => {
  const pageNumbers = useMemo(() => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      const range = [1];
      if (page > 3) range.push("...");
      for (
        let i = Math.max(2, page - 1);
        i <= Math.min(totalPages - 1, page + 1);
        i++
      ) {
        range.push(i);
      }
      if (page < totalPages - 2) range.push("...");
      range.push(totalPages);
      return range;
    }
  }, [page, totalPages]);

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        backgroundColor: "#fff",
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
      }}
    >
      <Button
        onClick={() => setPage((p) => Math.max(p - 1, 1))}
        disabled={page === 1}
      >
        Prev
      </Button>

      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        {pageNumbers.map((p, i) => (
          <Button
            key={i}
            onClick={() => typeof p === "number" && setPage(p)}
            variant={p === page ? "contained" : "text"}
            disabled={p === "..."}
          >
            {p}
          </Button>
        ))}
      </Box>

      <Button
        onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
        disabled={page === totalPages}
      >
        Next
      </Button>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography>Rows per page:</Typography>
        <Select
          size="small"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setPage(1);
          }}
        >
          {[10, 25, 50, 100].map((n) => (
            <MenuItem key={n} value={n}>
              {n}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

PaginationControl.propTypes = {
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  setPageSize: PropTypes.func.isRequired,
};

export default PaginationControl;
